module.exports = __webpack_public_path__ + "static/media/refund.e864365b.png";